<ng-container
  *ngIf="
    calcTypeVisibility.showNet ||
    calcTypeVisibility.showGross ||
    calcTypeVisibility.showPureGross
  "
>
  <div edsRow>
    <!-- NET SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showNet &&
        fundSummaryInfo?.net?.cummulativeReturnYearToDate
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo?.net?.performanceAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Ytd-Total-Returns-at-NET' | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo?.net?.cummulativeReturnYearToDate + '%'"
          caveatPlacement="Fund Summary:YtdTotalReturnsNetOverview"
          [valueTextLarge]="true"
        >
        </eds-summary-item>
      </div>
    </div>

    <!-- PUREGROSS SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showPureGross &&
        fundSummaryInfo?.pureGross?.cummulativeReturnYearToDate
      "
    >
      <div edsFlexbox>
        <small class="small">&nbsp;</small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Ytd-Total-Returns-at-PURE-GROSS'
              | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo?.pureGross?.cummulativeReturnYearToDate + '%'"
          caveatPlacement="Fund Summary:YtdTotalReturnsGrossOverview"
          [valueTextLarge]="true"
        >
        </eds-summary-item>
      </div>
    </div>

    <!-- GROSS SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showGross &&
        fundSummaryInfo?.gross?.cummulativeReturnYearToDate
      "
    >
      <div edsFlexbox>
        <small class="small">&nbsp;</small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Ytd-Total-Returns-at-GROSS' | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo?.gross?.cummulativeReturnYearToDate + '%'"
          caveatPlacement="Fund Summary:YtdTotalReturnsGrossOverview"
          [valueTextLarge]="true"
        >
        </eds-summary-item>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="fundSummaryInfo.nav">
  <div edsRow>
    <!-- WDE-4201 3yr Annualized return -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.show3YrAnnualReturn &&
        fundSummaryInfo?.performance?.monthEnd?.avgAnnual3YearReturn
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo?.performance?.monthEnd?.performanceAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Avg-Annual-3Year-Return-NET' | translate: brConfig.fundId
          "
          [val]="
            fundSummaryInfo?.performance?.monthEnd?.avgAnnual3YearReturn + '%'
          "
          caveatPlacement="Fund Summary:AvgAnnual3YearReturnNetOverview"
          [valueTextLarge]="true"
        >
        </eds-summary-item>
      </div>
    </div>

    <!-- NAV SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="calcTypeVisibility.showNav"
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.navAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <ng-container *ngIf="!hideVIPData">
          <eds-summary-item
            [theme]="componentTheme"
            [title]="'pds.NAV_VALUE' | translate: brConfig.fundId"
            [val]="fundSummaryInfo.nav.navValue"
            supplementaryText="{{ fundSummaryInfo.nav.navChangeValue }} ({{
              fundSummaryInfo.nav.navChangePercentage
            }})"
            valueDirection="{{ fundSummaryInfo.nav.changeDirection }}"
            caveatPlacement="Fund Summary:NavOverview"
            [valueTextLarge]="true"
          ></eds-summary-item>
        </ng-container>
        <ng-container *ngIf="hideVIPData">
          <eds-summary-item
            [theme]="componentTheme"
            [title]="'pds.NAV_VALUE' | translate: brConfig.fundId"
            [val]="fundSummaryInfo.nav.navValue"
            supplementaryText=""
            valueDirection=""
            caveatPlacement="Fund Summary:NavOverview"
            [valueTextLarge]="true"
          ></eds-summary-item>
        </ng-container>
      </div>
    </div>

    <!-- MONEY FUND NAV SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="calcTypeVisibility.showMoneyFundnav"
    >
      <div edsFlexbox>
        <div class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.navAsOfDate }}
        </div>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'pds.NAV_VALUE' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.moneyFundNav"
          supplementaryText="{{
            fundSummaryInfo.nav.moneyFundNavChangeValue
          }} ({{ fundSummaryInfo.nav.navChangePercentage }})"
          valueDirection="{{ fundSummaryInfo.nav.changeDirection }}"
          caveatPlacement="Fund Summary:NavOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- FUND LEVEL MARKET NAV SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showFundLevelMarket &&
        fundSummaryInfo?.nav?.moneyFundMarketNav
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.moneyFundAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Fund-Level-Market-Nav' | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo.nav.moneyFundMarketNav"
          caveatPlacement="Fund Summary:FundLevelMarketNavOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- MASTER FUND LEVEL MARKET NAV SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showMasterFundLevelMarket &&
        fundSummaryInfo?.nav?.masterFundNav
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.moneyFundAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Master-Fund-Level-Market-Nav' | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo.nav.masterFundNav"
          caveatPlacement="Fund Summary:MasterFundLevelMarketNavOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- LIQUID ASSET DAILY SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showLiquidAssetDaily &&
        fundSummaryInfo?.nav?.dailyLiquidAssetRatio
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.moneyFundAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'products.Liquid-Asset-Daily' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.dailyLiquidAssetRatio"
          caveatPlacement="Fund Summary:LiquidAssetsDailyOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- LIQUID ASSET WEEKLY SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showLiquidAssetWeekly &&
        fundSummaryInfo?.nav?.weeklyLiquidAssetRatio
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.moneyFundAsOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'products.Liquid-Asset-Weekly' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.weeklyLiquidAssetRatio"
          caveatPlacement="Fund Summary:LiquidAssetsWeeklyOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- INTRADAY NAV SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showIntraDayNav && fundSummaryInfo?.nav?.intradayNav
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.intradayNavDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'products.IntradayNav' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.intradayNav"
          caveatPlacement="Fund Summary:IntraDayNavOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- POP SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="calcTypeVisibility.showPop"
    >
      <div edsFlexbox>
        <small class="small">&nbsp;</small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'products.POP_VALUE' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.popValue"
          caveatPlacement="Fund Summary:POPOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- MARKET PRICE SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="calcTypeVisibility.showMarketPrice"
    >
      <div edsFlexbox>
        <small class="small">&nbsp;</small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'pds.MARKET_VALUE' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.marketPriceValue"
          supplementaryText="{{
            fundSummaryInfo.nav.marketPriceChangeValue
          }} ({{ fundSummaryInfo.nav.marketPriceChangePercentage }})"
          valueDirection="{{ fundSummaryInfo.nav.changeDirection }}"
          caveatPlacement="Fund Summary:MarketPriceOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- NAV YTD SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="calcTypeVisibility.showNavYTD"
    >
      <div edsFlexbox>
        <small *ngIf="calcTypeVisibility.showNavYTDAsOfDate" class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.nav.navAsOfDate }}
        </small>
        <small *ngIf="!calcTypeVisibility.showNavYTDAsOfDate" class="small"
          >&nbsp;
        </small>
      </div>
      <div
        edsFlexbox
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
        *ngIf="!hideVIPData"
      >
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Ytd-Total-Returns-at-NAV' | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo.nav.navYearToDateReturn"
          caveatPlacement="Fund Summary:YtdTotalReturnsNavOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- DISTRIBUTION RATE AT NAV -->
    <div
      *ngIf="
        calcTypeVisibility.showDistributionRateAtNav &&
        fundSummaryInfo?.distributionRateAtNav?.distributionRateBreakPoint
      "
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
    >
      <div edsFlexbox>
        <small class="small">&nbsp; </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.distribution-rate-NAV' | translate: brConfig.fundId
          "
          [val]="
            fundSummaryInfo?.distributionRateAtNav?.distributionRateBreakPoint
          "
          caveatPlacement="overview-DISTRIBUTION_RATE_AT_NAV-fund-information"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- MARKET PRICE YTD SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        calcTypeVisibility.showMarketPrice &&
        fundSummaryInfo.nav.marketPriceYearToDateReturn
      "
    >
      <div edsFlexbox>
        <small class="small">&nbsp; </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.Ytd-Total-Returns-at-MARKET_PRICE'
              | translate: brConfig.fundId
          "
          [val]="fundSummaryInfo.nav.marketPriceYearToDateReturn"
          caveatPlacement="Fund Summary:YtdTotalReturnsMarketPriceOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>

    <!-- PREMIUM DISCOUNT SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="calcTypeVisibility.showPremiumDiscount"
    >
      <div edsFlexbox>
        <small class="small">&nbsp; </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          [theme]="componentTheme"
          [title]="'products.Premium-Discount' | translate: brConfig.fundId"
          [val]="fundSummaryInfo.nav.premiumDiscountPct"
          caveatPlacement="Fund Summary:PremiumDiscountOverview"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>
    <!-- MORNING STAR SUMMARY -->
    <div
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 'auto' }"
      *ngIf="
        showRatings &&
        fundSummaryInfo.ratings?.morningStarRatingOverall &&
        fundSummaryInfo.ratings?.morningStarRatingOverall !== ''
      "
    >
      <div edsFlexbox>
        <small class="small">
          {{ "products.as-of" | translate: brConfig.fundId }}
          {{ fundSummaryInfo.ratings.asOfDate }}
        </small>
      </div>
      <div edsFlexbox [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'">
        <eds-summary-item
          theme="morningstar"
          [title]="'products.ratings-title' | translate"
          [supplementaryText]="fundSummaryInfo.ratings.morningStarCategory"
          caveatPlacement="Fund Summary:RatingsOverview"
          [tooltip]="'products.ratings-title-tooltip' | translate"
          (btnClick)="viewDetails()"
        >
          <eds-link-item
            href="/"
            [hasIcon]="true"
            type="new-window"
            [stopNavigation]="true"
            [title]="'products.ms-view-details' | translate"
            (onLinkClick)="viewDetails()"
          ></eds-link-item>
          <eds-rating
            [rating]="fundSummaryInfo.ratings.morningStarRatingOverall"
            size="normal"
            [isHybrid]="fundSummaryInfo.ratings.morningStarOverallHybrid"
            [title]="'products.morningstar-review' | translate"
          ></eds-rating>
          <button
            *ngIf="fundSummaryInfo.ratings.morningStarOverallHybrid"
            edsTooltip
            tooltipPositionDefault="top"
            [analyticsName]="'products.ratings-title' | translate"
            tooltipType="large"
            [tooltipContent]="'products.morningstar-tooltip' | translate"
            [tooltipAriaLabel]="'products.ratings-title' | translate"
            [tooltipButton]="true"
          >
            <eds-icon type="info" size="small"></eds-icon>
          </button>
        </eds-summary-item>
      </div>
    </div>
  </div>
  <!-- salesChargeBreakPoints for CEF (US specific) -->
  <ng-container *ngIf="calcTypeVisibility.showSalesChargeBreakPoints">
    <div edsRow>
      <div
        edsFlexbox
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
        edsCol
        [columnNumbers]="{ s: 2, m: 2, l: 2 }"
      >
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.distribution-rate-NAV' | translate: brConfig.fundId
          "
          [val]="
            fundSummaryInfo?.distributionRateAtNav?.distributionRateBreakPoint
          "
          caveatPlacement="overview-DISTRIBUTION_RATE_AT_NAV-fund-information"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
      <div
        edsFlexbox
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
        edsCol
        [columnNumbers]="{ s: 2, m: 2, l: 3 }"
      >
        <eds-summary-item
          [theme]="componentTheme"
          [title]="
            'products.distribution-rate-market-price'
              | translate: brConfig.fundId
          "
          [val]="
            fundSummaryInfo?.distributionRateAtMarketPrice
              ?.distributionRateBreakPoint
          "
          caveatPlacement="overview-DISTRIBUTION_RATE_AT_MARKET_PRICE-fund-information"
          [valueTextLarge]="true"
        ></eds-summary-item>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <ng-container>
    <ng-container>
      <ng-container>
        <div edsRow>
          <!--Skeleton loader-->
          <div
            edsCol
            [columnNumbers]="{ s: 2, m: 2, l: 2 }"
            [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
          >
            &nbsp;
            <div class="small" edsSpacing="xs">&nbsp;</div>
            <eds-summary-item theme="dark">&nbsp;</eds-summary-item>
          </div>
          <div
            edsCol
            [columnNumbers]="{ s: 2, m: 2, l: 2 }"
            [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
          >
            &nbsp;
            <small edsSpacing="xs">&nbsp;</small>
            <eds-summary-item theme="dark">&nbsp;</eds-summary-item>
          </div>
          <div
            edsCol
            [columnNumbers]="{ s: 2, m: 2, l: 2 }"
            [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
          >
            &nbsp;
            <div class="small" edsSpacing="xs">&nbsp;</div>
            <eds-summary-item theme="dark">
              <eds-icon size="normal" edsPadding edsPaddingRight="sm"
                >&nbsp;</eds-icon
              >
            </eds-summary-item>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
<eds-simple-modal
  [modalId]="ModalId['Morningstar_Modal']"
  size="large"
  aria-label="Close"
  [showHeader]="false"
  [showFooter]="false"
>
  <div modal-body>
    <ft-morning-star-details
      *ngIf="fundSummaryInfo?.ratings"
      [ratingData]="fundSummaryInfo.ratings"
    ></ft-morning-star-details>
  </div>
</eds-simple-modal>
